<div
  class="gains-select"
  [ngClass]="{
    'up-arrow': isSelectOpen,
    'down-arrow': !isSelectOpen,
    'error-input': displayError
  }"
>
  <!-- Label -->
  <label *ngIf="label" [for]="selectId" class="select-label">
    {{ label }}
    <span *ngIf="required">*</span>
  </label>
  <!-- Dropdown -->
  <nz-select
    [formControl]="internalFormControl"
    [nzPlaceHolder]="placeholder"
    [nzId]="selectId"
    [nzShowSearch]="showSearch"
    [nzSize]="size"
    [nzDropdownMatchSelectWidth]="dropdownMatchSelectWidth"
    [nzMode]="this.mode"
    [nzOpen]="isSelectOpen"
    (nzOpenChange)="onSelectOpenChange($event)"
    (nzBlur)="onBlur()"
    [nzCustomTemplate]="customTemplate"
    [nzAllowClear]="this.allowClear"
    [nzOptionOverflowSize]="this.optionOverflowSize"
    [nzShowArrow]="true"
    [ngClass]="this.className"
    [nzMaxTagCount]="this.maxTagCount"
    [nzMaxTagPlaceholder]="maxTagPlaceholder"
    [nzLoading]="this.loading"
    (resized)="onResized($event)"
    (ngModelChange)="onValueChange($event)"
  >
    <!-- "All" option -->
    <nz-option nzValue="__all__" nzLabel="All" nzCustomContent nzDisabled="true" all-option *ngIf="allCheckbox">
      <label
        class="flex-1 all-items-label"
        [for]="'all-items-checkbox'"
        (click)="toggleAll($event); $event.preventDefault()"
        [ngClass]="{ 'all-checkbox-row': this.allCheckbox }"
        tabindex="0"
        (keydown.enter)="toggleAll($event); $event.preventDefault()"
      >
        All
        <input id="all-items-checkbox" type="checkbox" [checked]="isAllSelected()" [indeterminate]="isIndeterminate()" />
      </label>
    </nz-option>

    <!-- The items, under their group's heading when they have one -->
    <ng-container *ngFor="let group of optionGroups">
      <ng-container *ngIf="group.label === null">
        <nz-option *ngFor="let item of group.items" [nzValue]="item" [nzLabel]="item.title" nzCustomContent [nzDisabled]="item?.disabledOption">
          <ng-container *ngTemplateOutlet="optionContent; context: { $implicit: item }"></ng-container>
        </nz-option>
      </ng-container>
      <nz-option-group *ngIf="group.label !== null" [nzLabel]="group.label">
        <nz-option *ngFor="let item of group.items" [nzValue]="item" [nzLabel]="item.title" nzCustomContent [nzDisabled]="item?.disabledOption">
          <ng-container *ngTemplateOutlet="optionContent; context: { $implicit: item }"></ng-container>
        </nz-option>
      </nz-option-group>
    </ng-container>
  </nz-select>

  <!-- An item in the dropdown -->
  <ng-template #optionContent let-item>
    <div class="icon-title" [ngClass]="{ 'all-checkbox-row': this.allCheckbox }">
      <span class="icon-title">
        <svg-icon *ngIf="item.icon && !item.showOnRight" [src]="'assets/icons/' + item.icon" class="option-icon"></svg-icon>
        {{ item.title }}
        <span *ngIf="item.tooltip" class="option-tooltip">
          <svg-icon
            src="assets/icons/circle-question.svg"
            [nz-tooltip]="tooltipHeaderTpl"
            [nzTooltipTrigger]="'hover'"
            [nzTooltipPlacement]="item.showOnRight ? 'right' : undefined"
          ></svg-icon>
          <ng-template #tooltipHeaderTpl>
            <ng-container *ngIf="item.showOnRight">
              <span class="font-bold">{{ item.title }}</span
              ><br />
            </ng-container>
            <span>{{ item.tooltip }}</span>
          </ng-template>
        </span>
      </span>
      <small *ngIf="item.hint" class="option-hint">{{ item.hint }}</small>
    </div>
    <label *ngIf="this.allCheckbox && this.mode === 'multiple'" class="item-checkbox-wrap" [attr.aria-label]="item.title">
      <input type="checkbox" [checked]="internalFormControl.value?.includes(item)" readonly [disabled]="item?.disabledOption" />
    </label>
    <svg-icon *ngIf="this.internalFormControl?.value === item && !this.allCheckbox" src="assets/icons/check.svg" class="check-icon"></svg-icon>
  </ng-template>

  <ng-template #maxTagPlaceholder let-selectedList>+ {{ selectedList.length }}</ng-template>

  <!-- Custom Template -->
  <ng-template #customTemplate let-selected>
    <div class="custom-selected">
      <svg-icon *ngIf="selected?.nzValue?.icon && !selected?.nzValue?.showOnRight" [src]="'assets/icons/' + selected.nzValue.icon" class="selected-icon"></svg-icon>
      <span>{{ selected?.nzLabel }}</span>
    </div>
  </ng-template>
</div>
<div class="error-message" *ngFor="let message of errorMessagesToDisplay">
  <svg-icon src="assets/icons/exclamation-circle.svg"></svg-icon>
  <span>{{ message }}</span>
</div>
